import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDialogModule} from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatExpansionModule} from '@angular/material/expansion';
const materialComponent = [
  MatExpansionModule,
  MatSidenavModule,
  MatSelectModule,
  MatTableModule,
  MatButtonModule,
  MatMenuModule,
  MatInputModule,
  MatSlideToggleModule,
  MatRadioModule,
  ScrollingModule,
  MatFormFieldModule,
  MatDialogModule,
  MatListModule,
  MatChipsModule,
  MatIconModule,
  MatAutocompleteModule
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    materialComponent,
  ],
  exports: [
    materialComponent
  ]
})
export class MaterialModule { }
